import { ICollectionMetadata } from "@novel/shared/interfaces/CollectionMetadata";
import { ISODateString } from "@novel/shared/interfaces/shared/ISODateString";

export function checkIsUnrevealed(collectionMetadata: ICollectionMetadata): boolean {
    return (
        !collectionMetadata.revealedOn &&
        !!collectionMetadata.revealingOn &&
        ISODateString.isInFuture(collectionMetadata.revealingOn)
    );
}
